<template>
  <div>
    <div v-if="preloader">
      <div
        class="d-flex align-center justify-center flex-column"
        style="height: 100vh"
      >
        <bubble-loader />
      </div>
    </div>
    <div v-else>
      <div class="custom-container pt-6">
        <v-card
          height="64px"
          width="100%"
          class="background mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
          style="
            position: fixed;
            z-index: 200;
            top: 0;
            width: 98%;
            padding-top: 16px;
          "
        >
          <v-card-title class="ml-0 pl-0">
            <p class="breadcrumb-text">Dashboard</p>
            <span
              ><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span
            >
          </v-card-title>
          <UserNavMenu />
        </v-card>
        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="12" md="12" class="d-flex justify-end">
            <v-btn
              @click="filterDialog = true"
              dense
              rounded
              class="btn outline-btn elevation-0 mx-2"
              ><v-icon class="pr-2">mdi-tune</v-icon>
              <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
              <span v-else>Filter</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="6" md="6" class="d-flex flex-column">
            <v-card
              class="fill-height d-flex flex-row align-center"
              elevation="2"
              v-if="mainsInterviewerScoresData.isDataAvailable"
              style="padding: 20px"
            >
              <!-- 🟢 LEFT SECTION: Title, Subtitle (on top) + Legend (below) -->
              <div
                style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  height: 100%;
                  padding-right: 20px;
                "
              >
                <!-- 🔸 Title + Subtitle at top -->
                <div>
                  <span class="chart-title">Mains vs Interviewer Score</span>
                  <div style="font-size: 12px; margin-top: 4px">
                    Compare average mains score and interviewer score across
                    Core Skill, Pedagogy, Digital Literacy, Communication
                    Skill and Psychometry.
                  </div>
                </div>

                <!-- 🔹 Legend at bottom of left section -->
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    margin-top: auto;
                    padding-bottom: 24px;
                  "
                  >
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #5ad684;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">Average Mains Score</span>
                  </div>

                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #ffb86b;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px"
                      >Average Interviewer Score</span
                    >
                  </div>
                </div>
              </div>

              <!-- 🔵 RIGHT SECTION: Bar Chart -->
              <div
                style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: flex-end;
                  padding-left: 40px;
                "
              >
                <!-- Bars Wrapper -->
                <div
                  style="
                    display: flex;
                    gap: 44px;
                    justify-content: center;
                    align-items: flex-end;
                  "
                >
                  <!-- System Score Bar -->
                  <div
                    style="
                      width: 40px;
                      height: 260px;
                      background-color: #e0e0e0;
                      border-radius: 20px;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: end;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        background-color: #5ad684;
                        border-radius: 0 0 20px 20px;
                        transition: height 0.3s ease;
                      "
                      :style="`height:${calculatePosition(
                        mainsInterviewerScoresData.averageMainsScore
                      )}%`"
                    >
                      <div
                        style="
                          position: relative;
                          top: -25px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 40px;
                          width: 40px;
                          border-radius: 20px;
                          border: 2px solid #099438;
                          background-color: #82e0b7;
                          font-size: 12px
                        "
                      >
                        {{ mainsInterviewerScoresData.averageMainsScore }}
                      </div>
                    </div>
                  </div>

                  <!-- Interviewer Score Bar -->
                  <div
                    style="
                      width: 40px;
                      height: 260px;
                      background-color: #e0e0e0;
                      border-radius: 20px;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: end;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        background-color: #ffb86b;
                        border-radius: 0 0 20px 20px;
                        transition: height 0.3s ease;
                      "
                      :style="`height:${calculatePosition(
                        mainsInterviewerScoresData.averageInterviewerScore
                      )}%`"
                    >
                      <div
                        style="
                          position: relative;
                          top: -25px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 40px;
                          width: 40px;
                          border-radius: 20px;
                          border: 2px solid #c6761f;
                          background-color: #ffcd97;
                          font-size: 12px
                        "
                      >
                        {{ mainsInterviewerScoresData.averageInterviewerScore }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🏷️ Label Below Bars -->
                <div style="margin-top: 10px; text-align: center">
                  <span style="font-size: 12px">Average Score</span>
                </div>
              </div>
            </v-card>
            <!--  -->

            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> Mains Vs Interviewer Score </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6" class="d-flex flex-column">
            <v-card class="pa-4 d-flex flex-column" elevation="2" v-if="demoParameterData.isDataAvailable">
              <div
                class="d-flex justify-space-between align-center"
                style="width: 100%"
              >
                <!-- Left side: Text -->
                <div>
                  <span class="chart-title"> Demo Parameter Comparison </span>
                  <div style="font-size: 12px">
                    Compares average system score and interviewer rating across
                    4 parameters
                  </div>
                </div>

                <!-- Right side: Buttons -->
              </div>

              <!-- Chart stays centered below -->
              <div class="flex-grow-1 d-flex justify-center align-center">
                <DemoParameterComparisonChart
                  :systemScore="demoParameterData.systemScores"
                  :interviewerScore="demoParameterData.interviewerScores"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> System Vs Interviewer Recommendations </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="12" md="12" class="d-flex flex-column">
            <v-card class="pa-4 d-flex flex-column" elevation="2" v-if="systemInterviewerRecommendationData.isDataAvailable">
              <span class="chart-title">
                System Vs Interviewer Recommendations
              </span>
              <div style="font-size: 12px">
                Compares system and interviewer Recommendations based on average
                scores
              </div>
              <div class="flex-grow-1 d-flex justify-center align-center">
                <SystemVsInterviewerReccomendationChart
                  :labels="['', 'Recommended', 'Not Recommended', 'On Hold']"
                  :datasets="[
                    {
                      label: 'System',
                      backgroundColor: '#439AFF',
                      data: systemInterviewerRecommendationData.systemRecommendation,
                      borderColor: '#5AD684',
                      backgroundColor: 'transparent', // ✅ No fill under the line

                      pointBackgroundColor: '#5AD68499', // Optional: point color
                      pointBorderColor: '#5AD68499', //
                      pointRadius: 5, // ✅ Increase dot size (default is 3)
                      pointHoverRadius: 10,
                    },
                    {
                      label: 'Interviewer',
                      backgroundColor: '#FF6FEC',
                      data: systemInterviewerRecommendationData.interviewerRecommendation,
                      borderColor: '#FF6FEC', // ✅ Line color
                      backgroundColor: 'transparent', // ✅ No fill under the line

                      pointBackgroundColor: '#FF6FEC99', // Optional: point color
                      pointBorderColor: '#FF6FEC99', //
                      pointRadius: 5, // ✅ Increase dot size (default is 3)
                      pointHoverRadius: 10,
                    },
                  ]"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> System Vs Interviewer Recommendations </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
          <v-card width="570px" height="100vh" class="filterDialogClass d-flex flex-column">
            <v-row class="mt-4 mx-1">
              <v-col>
                <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
                  Filter
                </div>
              </v-col>
              <v-col class="d-flex justify-end">
                <div @click="clearFilter" class="clear-filter-btn">
                  CLEAR FILTER
                </div>
              </v-col>
            </v-row>

            <v-tabs vertical>
              <div class="ml-3 mt-4 mr-4 filterLine">
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>Campaign</span>
                    <span v-if="filters.campaign.selected.length > 0" class="ml-1">
                      <div class="status-count-badge">
                        <p>
                          1
                        </p>
                      </div>
                      </span>
                  </div>
                </v-tab>
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>Group</span>
                    <span v-if="filters.group.selected.length > 0">
                      <div class="status-count-badge">
                        <p>
                          {{ filters.group.selected.length }}
                        </p>
                      </div>
                    </span>
                  </div>
                </v-tab>

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>School</span>
                    <span v-if="filters.school.selected.length > 0" class="ml-1"
                      ><div class="status-count-badge">
                        <p>{{ filters.school.selected.length }}</p>
                      </div></span
                    >
                  </div>
                </v-tab>
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>HRIS Unique Role</span>
                    <span v-if="filters.hrisRole.selected.length > 0" class="ml-1"
                      ><div class="status-count-badge">
                        <p>{{ filters.hrisRole.selected.length }}</p>
                      </div></span
                    >
                  </div>
                </v-tab>
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>Interview Status</span>
                    <span v-if="filters.interviewStatus.selected.length > 0" class="ml-1"
                      ><div class="status-count-badge">
                        <p>{{ filters.interviewStatus.selected.length }}</p>
                      </div></span
                    >
                  </div>
                </v-tab>
              </div>
              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-text-field
                      v-model="searchTerms.campaign"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="px-4"
                    />
                  
                    <v-chip-group
                      v-model="filters.campaign.selected"
                      
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredData.campaign"
                        :key="index"
                        :value="item.id"
                        elevated
                      >
                        {{ item.name }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-text-field
                      v-model="searchTerms.group"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="px-4"
                    />

                    <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': allSelectedStatus.group }"
                      @click="toggleAll('group')"
                      elevated
                    >
                      All
                    </v-chip>

                    <v-chip-group
                      v-model="filters.group.selected"
                      multiple
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredData.group"
                        :key="index"
                        :value="item"
                        elevated
                      >
                        {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                    <div class="px-4 pt-2 pb-0">
                    <v-text-field
                      v-model="searchTerms.school"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="mb-2"
                    />

                    <!-- "All" Chip (stays under the search field, not scrolled away) -->
                    <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': allSelectedStatus.school }"
                      @click="toggleAll('school')"
                      elevated
                    >
                      All
                    </v-chip>
                  </div>

                  <!-- Scrollable Chips Section -->
                  <div
                    id="myScroll"
                    class="flex-grow-1 overflow-y-auto px-4 pb-4"
                    style="max-height: calc(680px - 315px)"
                  >
                    <v-chip-group
                      v-model="filters.school.selected"
                      multiple
                      column
                      active-class="active-chip"
                    >
                    <v-chip
                        v-for="(item, index) in filteredData.school"
                        :key="index"
                        :value="item"
                        elevated
                      >
                        {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="680px" id="myScroll">
                  <div class="px-4 pt-2 pb-0">
                    <v-text-field
                      v-model="searchTerms.hrisRole"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="mb-2"
                    />

                    <!-- "All" Chip (stays under the search field, not scrolled away) -->
                    <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': allSelectedStatus.hrisRole }"
                      @click="toggleAll('hrisRole')"
                      elevated
                    >
                      All
                    </v-chip>
                  </div>

                  <!-- Scrollable Chips Section -->
                  <div
                    id="myScroll"
                    class="flex-grow-1 overflow-y-auto px-4 pb-4"
                    style="max-height: calc(680px - 315px)"
                  >
                    <v-chip-group
                      v-model="filters.hrisRole.selected"
                      multiple
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredData.hrisRole"
                        :key="index"
                        :value="item.HRIS_unique_role"
                        elevated
                      >
                        {{ item.HRIS_unique_role }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-text-field
                      v-model="searchTerms.interviewStatus"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="px-4"
                    />

                    <v-chip
                      class="mb-2"
                      :class="{
                        'active-chip': allSelectedStatus.interviewStatus,
                      }"
                      @click="toggleAll('interviewStatus')"
                      elevated
                    >
                      All
                    </v-chip>

                    <v-chip-group
                      v-model="filters.interviewStatus.selected"
                      multiple
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredData.interviewStatus"
                        :key="index"
                        :value="item"
                        elevated
                      >
                        {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!--  -->
            </v-tabs>

            <div class="filterDialogButton">
              <v-card-actions class="px-6 pb-3">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  depressed
                  class="btn outline-btn font-weight-medium pa-4"
                  @click="filterDialog = false"
                  >Cancel</v-btn
                >
                <v-btn
                  rounded
                  class="btn primary-btn pa-4"
                  @click="
                    (filterDialog = false),
                      filterData(),
                      getFilterCount(),
                      (isApply = true)
                  "
                  >Apply</v-btn
                >
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";

import SchoolController from "@/controllers/SchoolController";

import CampaignController from "@/controllers/CampaignController";

import DashboardController from "@/controllers/DashboardController";
import DemoParameterComparisonChart from "@/components/ComparisonDashboard/DemoParameterComparisonChart.vue";
import SystemVsInterviewerReccomendationChart from "@/components/ComparisonDashboard/SystemVsInterviewerReccomendationChart.vue";
import AudienceRolesController from "@/controllers/AudienceRolesController";
export default {
  components: {
    BubbleLoader,
    UserNavMenu,
    DemoParameterComparisonChart,
    SystemVsInterviewerReccomendationChart,
  },
  data() {
    return {
      preloader: true,
      filterCount: 0,
      filterDialog: false,
      selectedGroupFilter: [],
      selectedSchoolFilter: [],
      selectedCampaignFilter: [],
      selectedInterviewStatusFilter: [],
      selectedHrisRoleFilter: [],
      schoolList: [],
      searchTerms: {
      campaign: "",
      group: "",
      school: "",
      hrisRole: "",
      interviewStatus: "",
      },
      campaigns: [],
      isApply: false,
      schoolsWithCode: [],
      mainsInterviewerScoresData:{},
      demoParameterData:{},
      systemInterviewerRecommendationData:{},
      
      total:null,
      filters: {
        campaign: {
          list: [], // your campaigns array
          selected: [],
          allKey: "name", // property to display/filter by
        },
        group: {
          list: [], // your groups array
          selected: [],
        },
        school: {
          list: [], // your schoolList array
          selected: [],
        },
        hrisRole: {
          list: [],
          selected: [],
          allKey: "HRIS_unique_role",
        },
        interviewStatus: {
          list: ["All", "ACCEPT", "REJECT"],
          selected: ["All", "ACCEPT", "REJECT"],
          
        },
      },
    };
  },

  methods: {
    async getChartData(){
      this.preloader = true;
        // 🔹 Build request body
      const requestBody = {
        groupFilter:
          this.filters.group.selected.filter(item => item !== "All").length > 0 &&
            this.filters.group.selected.filter(item => item !== "All").length < (this.filters.group.list.length - 1)
            ? this.filters.group.selected.filter(item => item !== "All").join(",")
            : "All",

        schoolFilter:
          this.filters.school.selected.filter(item => item !== "All").length > 0 &&
            this.filters.school.selected.filter(item => item !== "All").length <= this.schoolList.length
            ? this.schoolsWithCode
              .filter((school) =>
                this.filters.school.selected.filter(item => item !== "All").includes(school.name)
              )
              .map((school) => school.schoolCode)
              .join(",")
            : "All",

        campaignFilter: this.filters.campaign.selected.length > 0 &&
          this.filters.campaign.selected.length < this.filters.campaign.list.length
          ? this.filters.campaign.list[0]?.id || null : this.filters.campaign.list[0]?.id || null,
        jobRoleFilter:
          this.filters.hrisRole.selected.length > 0 &&
            this.filters.hrisRole.selected.length < this.filters.hrisRole.list.length
            ? this.filters.hrisRole.selected.join(",")
            : "All",
        interviewStatusFilter:
          this.filters.interviewStatus.selected.filter(item => item !== "All").length > 0 &&
            this.filters.interviewStatus.selected.filter(item => item !== "All").length < (this.filters.interviewStatus.list.length - 1)
            ? this.filters.interviewStatus.selected.filter(item => item !== "All").join(",")
            : "All",

      };
      
      this.getFilterCount();
      const response = await DashboardController.getComparisonDashboardData(requestBody);
      
      if (response) {
        this.mainsInterviewerScoresData = response.dashboardData.mainsInterviewerScoresData;
        this.demoParameterData = response.dashboardData.demoParameterData
        this.systemInterviewerRecommendationData = response.dashboardData.systemInterviewerRecommendationData;


        this.systemScores = response.dashboardData.demoParameterData.systemScores
        this.interviewerScores = response.dashboardData.demoParameterData.interviewerScores;
        
        this.systemRecommendation = response.dashboardData.systemInterviewerRecommendationData.systemRecommendation;

        this.interviewerRecommendation = response.dashboardData.systemInterviewerRecommendationData.interviewerRecommendation;
        this.systemRecommendation.unshift(0);
        this.interviewerRecommendation.unshift(0);
        
        this.total = this.mainsInterviewerScoresData.total
      }
      this.preloader = false;
    },
    async getAudienceRoles(){
      const response = await AudienceRolesController.getAudienceRoles();
      if (response.status == 200) {
        this.filters.hrisRole.list = response.data.audienceRoles;
        this.filters.hrisRole.selected = this.filters.hrisRole.list.map(hrisRole => hrisRole.HRIS_unique_role);
    
      } else {
        alert("Campaigns Not Found!!");
      }
    },
    async getAudienceRoleGroups(){
      const response = await AudienceRolesController.getAudienceRoleGroups();
      if(response.status==200){
        const audienceRoleGroups = response.data.audienceRoleGroup.map(({name}) => name);
        this.filters.group.list = this.filters.group.selected = ["All", ...audienceRoleGroups];
      }
    },
    toggleAll(type) {
      const filter = this.filters[type];
      const filtered = this.filteredData[type];
      const isAllSelected = this.allSelectedStatus[type];

      const getValue = (item) => (filter.allKey ? item[filter.allKey] : item);

      if (isAllSelected) {
        filter.selected = [];
      } else {
        filter.selected = filtered.map((item) => getValue(item));
      }
    },
    calculatePosition(value) {
      let position = (value / this.total) * 100;
      return position > 90 ? 90 : position < 5 ? 5 : position;
    },

    filterData() {
      this.filterUsersLoader = true;
      this.getFilterCount();
      this.getChartData();
      this.filterUsersLoader = false;
      this.filterDialog = false;

      this.filters.group.selected = this.filters.group.selected.length <= 0 ? this.filters.group.list : this.filters.group.selected;

      this.filters.school.selected = this.filters.school.selected.length <= 0 ? this.schoolList : this.filters.school.selected;

      this.filters.campaign.selected = this.filters.campaign.selected.length <= 0 ? this.filters.campaign.list[0]?.id || null : this.filters.campaign.selected;

      this.filters.interviewStatus.selected = this.filters.interviewStatus.selected.length <= 0 ? this.filters.interviewStatus.list : this.filters.interviewStatus.selected;

      this.filters.hrisRole.selected = this.filters.hrisRole.selected.length <= 0 ? this.filters.hrisRole.list.map(hrisRole => hrisRole.HRIS_unique_role) : this.filters.hrisRole.selected;

    },

  clearFilter() {
  this.isApply = false;
  this.searchTerm = ""; // Clear search term
  
  // Clear all filter selections
  Object.keys(this.filters).forEach(key => {
    this.filters[key].selected = [];
  });
  
  this.getFilterCount();
},
    getFilterCount() {
  this.filterCount = Object.values(this.filters)
    .filter(filter => filter.selected && filter.selected.length > 0)
    .length;
},

    async getSchool() {
      const schools = this.$store.state.role.schoolCodes;
      const query = `?schoolCodes=${schools}`;

      const response = await SchoolController.getSchoolByCode(query);
      if (response.status == 200) {
        this.schoolsWithCode = response.data.schools;
        this.schoolList = this.schoolsWithCode.map((school) => school.name);
        
    
        this.filters.school.list = this.schoolsWithCode.map(
          (school) => school.name
        );
        this.filters.school.selected = this.schoolList;
        
      } else {
        alert("Schools Not Found!!");
      }
    },
    async getCampaigns() {
      const response = await CampaignController.fetchCampaigns();
      if (response.status == 200) {
        this.filters.campaign.list = response.data.campaigns;
        this.filters.campaign.selected = this.filters.campaign.list[0]?.id || null;
      } else {
        alert("Campaigns Not Found!!");
      }
    },
  },
computed: {
  filteredData() {
    const result = {};

    for (const [key, filter] of Object.entries(this.filters)) {
      // Safety check: ensure filter and filter.list exist
      if (!filter || !filter.list) {
        result[key] = [];
        continue;
      }

      let items = [...filter.list]; // Create a copy to avoid mutations

      // Support objects (like campaigns) or simple strings (like schools)
      const getValue = (item) => (filter.allKey ? item[filter.allKey] : item);

      // Remove "All" items if they exist
      items = items.filter((item) => {
        const value = getValue(item);
        return value !== "All";
      });

      // Apply search filtering
      const term = this.searchTerms[key]?.toLowerCase() || "";
      if (term) {
        items = items.filter((item) => {
          const value = getValue(item);
          return value && value.toString().toLowerCase().includes(term);
        });
      }

      result[key] = items;
    }

    return result;
  },

  allSelectedStatus() {
    const result = {};
    
    for (const [key, filter] of Object.entries(this.filters)) {
      // Safety check
      if (!filter || !this.filteredData[key]) {
        result[key] = false;
        continue;
      }

      const filtered = this.filteredData[key];
      const getValue = (item) => (filter.allKey ? item[filter.allKey] : item);
      
      result[key] =
        filtered.length > 0 &&
        filter.selected &&
        filtered.every((item) => filter.selected.includes(getValue(item)));
    }
    
    return result;
  },
},

  async mounted() {
    await Promise.all([
      this.getSchool(),
      this.getAudienceRoles(),
      this.getAudienceRoleGroups(),
      this.getCampaigns(),
    ]);
    await this.getChartData();
  },
};
</script>
<style scoped>
.custom-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  margin: 24px;
  margin-top: 55px;
  margin-right: 55px;
  padding-right: 55px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
}
.custom-gray-text {
  background-color: #cfd5f1 !important;
}
.no-uppercase {
  text-transform: none !important;
}
.icon {
  cursor: pointer;
  transition: opacity 0.3s, filter 0.3s;
}
</style>
